<template>
  <div>
    <el-dialog :title="`Visitors list (${selectedMonth})`" :visible.sync="dialogVisible" @close="closeDialog()">
      <el-table :data="visitors.data">
        <el-table-column property="user.name" label="User Name (From Brac bank)" width="300"></el-table-column>
        <el-table-column property="user.username" label="Pin"></el-table-column>
      </el-table>

      <el-pagination v-if="visitors.total > visitors.per_page"
        background
        layout="prev, pager, next"
        @current-change="getVisitors"
        :page-size="visitors.per_page"
        :pager-count="5"
        :total="visitors.total"
        :current-page="visitors.current_page"
        class="float-right"
      >
      </el-pagination>
      <br>
    </el-dialog>
  </div>
</template>


<script>

import {CommonAPI} from "@/services/api"

export default {
  data: () => ({
    dialogVisible: false,
    visitors: {},
    selectedMonthNo: '',
    selectedMonth: '',
  }),
  components: {
    VuePagination: () => import('@/components/partials/PaginationComponent')
  },
  computed: {
    //
  },
  mounted() {
    this.$parent.$on('visitors-list', this.enableModal)
  },
  methods: {
    enableModal(month) {
      this.selectedMonth = this.$options.filters.monthName(month)
      this.selectedMonthNo = month
      this.getVisitors(1)
      this.dialogVisible = true
    },
    getVisitors(page = 1) {
      this.is_loading = true
      let q = JSON.parse(JSON.stringify(this.$route.query))
      let params = { ...{month: this.selectedMonthNo, page: page}, ...q }

      CommonAPI.monthlyVisitors(params).then(visitors => {
        this.visitors = visitors
      }).catch(error => {
        console.log('error: ', error)
      }).finally(() => {
        this.is_loading = false
      })
    },
    closeDialog() {
      this.visitors = {}
    }
  },
  filters: {
    monthName: function (value) {
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      return months[value - 1] || '' // Subtract 1 to match array index
    }
  }
}
</script>
